import {ElementRef, Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "cssVar"})
export class CssVarPipe implements PipeTransform {
    constructor(private element: ElementRef) {
    }

    /**
     * Return value of specified CSS variable
     * @param value
     * @returns string
     */
    transform(value): string {
        if (!value.startsWith("--")) {
            return value;
        }
        let result: string = getComputedStyle(this.element.nativeElement).getPropertyValue(value).trim();
        if (!result) {
            result = getComputedStyle(document.documentElement).getPropertyValue(value).trim();
        }
        return result;
    }
}



// WEBPACK FOOTER //
// ./src/app/html-utils/css-var.pipe.ts